














































































































































































































































































































































import {Component} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {$} from '@/facade'
import {OrbitHelper} from '@/helpers/OrbitHelper'
import {
  OrbitNetworkHelper,
  OrbitNetworkOption,
} from '@/helpers/OrbitNetworkHelper'
import {currentN3Network} from '@/helpers/NetworkModeRegistry'
import {NetworkNamespace} from '@/enums/NetworkNamespace'
import {InputSelect} from '@simpli/vue-input'
import ConnectWalletModal from '@/components/walletConnection/ConnectWalletModal.vue'
import OrbitAddOwnerModal from '@/components/orbit/OrbitAddOwnerModal.vue'
import OrbitRemoveOwnerModal from '@/components/orbit/OrbitRemoveOwnerModal.vue'

/** An Orbit owner as the contract of one network returns it. */
type OrbitOwner = {
  key: string
  address: string
  network: string
}

type KnownOwner = {name: string; ledger: boolean}

const KNOWN_OWNERS: Record<string, KnownOwner> = {
  NccqaMHsTjeSJYqoW47uzD3eE39wGSe3gN: {name: 'Dean', ledger: true},
  NcK9wzk74Rj9ztBRBFH2VLAB3kTYspmDur: {name: 'Verv', ledger: true},
  NYK8n1Ce65xSz9LzrGr9fr4nk8ZsRzibHN: {name: 'Lopes', ledger: true},
  NQFS975PXcnjmZP7xt6wDREhLdgyJvDhkG: {name: 'Orbit', ledger: false},
  NePDMw6LFq7DMa9QoLU71EmRD7JcafdkYB: {name: 'Verv', ledger: false},
}

@Component({
  components: {
    ConnectWalletModal,
    OrbitAddOwnerModal,
    OrbitRemoveOwnerModal,
    InputSelect,
  },
})
export default class ListOrbitOwnersView extends MixinScreenSize {
  owners: OrbitOwner[] = []
  /** Networks whose Orbit contract could not be read on the last load. */
  unreachableNetworks: string[] = []

  newOwnerAddress = ''
  showAddOwnerModal = false
  showRemoveOwnerModal = false
  selectedOwnerAddress = ''
  networkFilter: string | null = null

  /**
   * The network every signature goes to — the one picked in the network bar.
   * The list shows both networks, but adding/removing an owner runs through the
   * wallet adapters, which are wired to this one alone.
   */
  get activeNetwork(): string {
    return currentN3Network()
  }

  get filteredOwners(): OrbitOwner[] {
    if (!this.networkFilter) return this.owners

    return this.owners.filter(owner => owner.network === this.networkFilter)
  }

  get isConnectedOwner(): boolean {
    const address = $.walletAdapter.n3Address
    if (!address) return false

    return this.owners.some(
      owner => owner.address === address && owner.network === this.activeNetwork
    )
  }

  get canMutateOwners(): boolean {
    return !!$.walletAdapter.n3Address && this.isConnectedOwner
  }

  get networkFilterOptions(): OrbitNetworkOption[] {
    return OrbitNetworkHelper.options(this.$translate('view.orbitNetwork.all'))
  }

  get networkFilterSelectValue(): OrbitNetworkOption | null {
    return OrbitNetworkHelper.optionOf(
      this.networkFilterOptions,
      this.networkFilter
    )
  }

  set networkFilterSelectValue(option: OrbitNetworkOption | null) {
    this.networkFilter = !option || option.$id === '' ? null : option.$id
  }

  networkLabel(networkIdentifier: string | null): string {
    return OrbitNetworkHelper.label(networkIdentifier)
  }

  networkBadgeClass(networkIdentifier: string | null): string {
    return OrbitNetworkHelper.badgeClass(networkIdentifier)
  }

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    await this.$await.run('populateOrbitOwners', async () => {
      const networks = OrbitNetworkHelper.identifiers

      // One network being down must not blank out the other one's owners.
      const results = await Promise.all(
        networks.map(async network => {
          try {
            return {network, addresses: await OrbitHelper.getOwners(network)}
          } catch (err) {
            console.error(`Failed to load Orbit owners of ${network}:`, err)
            return {network, addresses: null}
          }
        })
      )

      this.owners = results.flatMap(({network, addresses}) =>
        (addresses || []).map(address => ({
          key: `${network}|${address}`,
          address,
          network,
        }))
      )

      this.unreachableNetworks = results
        .filter(result => result.addresses === null)
        .map(result => result.network)
    })
  }

  connectN3Address() {
    $.modal.open('connectWalletModal', {
      networkNamespace: NetworkNamespace.n3,
    })
  }

  disconnectN3Address() {
    $.walletAdapter.disconnectN3Wallet()
  }

  copyToClipboard(val: string) {
    this.$utils.copyToClipboard(val)
    this.$toast.info('system.info.copiedToClipboard')
  }

  openAddOwnerModal() {
    if (!this.newOwnerAddress) return
    this.showAddOwnerModal = true
  }

  async handleCloseAddOwnerModal() {
    this.showAddOwnerModal = false
    this.newOwnerAddress = ''
    await this.populateResources()
  }

  canRemoveOwner(owner: OrbitOwner): boolean {
    return this.canMutateOwners && owner.network === this.activeNetwork
  }

  removeOwnerDisabledReason(owner: OrbitOwner): string {
    if (owner.network !== this.activeNetwork) {
      return this.$translate('view.ListOrbitOwnersView.switchNetworkToMutate')
    }

    return ''
  }

  openRemoveOwnerModal(owner: OrbitOwner) {
    if (!owner?.address) return
    if (owner.network !== this.activeNetwork) {
      $.toast.error('view.ListOrbitOwnersView.switchNetworkToMutate')
      return
    }
    this.selectedOwnerAddress = owner.address
    this.showRemoveOwnerModal = true
  }

  async handleCloseRemoveOwnerModal() {
    this.showRemoveOwnerModal = false
    this.selectedOwnerAddress = ''
    await this.populateResources()
  }

  ownerName(address: string): string | null {
    return KNOWN_OWNERS[address]?.name ?? null
  }

  isLedgerWallet(address: string): boolean {
    return KNOWN_OWNERS[address]?.ledger === true
  }
}
